import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { ReactComponent as CloseIcon } from "../../Assets/icon/X-grey.svg";

const SummaryBottomSheet = ({
  open,
  eyebrow,
  title,
  text,
  onClose,
  onPickOption,
  options = [],
  showGenerateButton = false,
  onGenerateSummaries,
  generating = false,
  summariesLoaded = false,
  summaryStatus = null,
}) => {
  const isProcessing = summariesLoaded && summaryStatus === "processing";
  const hasOptions = Array.isArray(options) && options.length > 0;
  const primaryOption = hasOptions ? options[options.length - 1] : null;
  const pillOptions = hasOptions ? options.slice(0, -1) : [];

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="summary-sheet-overlay" role="dialog" aria-modal="true">
      <div className="summary-sheet">
        <div className="summary-sheet-topbar">
          <button
            className="summary-sheet-close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="summary-sheet-body">
          {eyebrow && <p className="summary-sheet-eyebrow">{eyebrow}</p>}
          <div className="summary-sheet-heading-row">
            <h2 className="summary-sheet-title-large">{title}</h2>
          </div>

          {isProcessing && (
            <div className="summary-sheet-status">
              Summary generation is in progress...
            </div>
          )}

          {showGenerateButton && summariesLoaded && (
            <div className="summary-sheet-generate-row">
              <button
                type="button"
                className="summary-sheet-generate-btn"
                onClick={onGenerateSummaries}
                disabled={generating}
              >
                {generating ? "Generating Summaries..." : "Generate Summaries"}
              </button>
            </div>
          )}

          <div className="summary-sheet-summary-box">
            <div className="summaries-text">
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {text || ""}
              </ReactMarkdown>
            </div>
          </div>

          {summariesLoaded && !isProcessing && hasOptions && (
            <>
              <div className="summary-sheet-divider" />
              <p className="summary-sheet-options-header">
                Talk it through with Aris
              </p>
              <div className="summary-sheet-options">
                {pillOptions.map((opt, idx) => (
                  <button
                    key={`pill-${idx}`}
                    type="button"
                    className="summary-sheet-option"
                    onClick={() => onPickOption && onPickOption(opt, false)}
                  >
                    {opt}
                  </button>
                ))}
                {primaryOption && (
                  <button
                    type="button"
                    className="summary-sheet-option summary-sheet-option-primary"
                    onClick={() => onPickOption && onPickOption(primaryOption, true)}
                  >
                    {primaryOption}
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryBottomSheet;
